import { Link } from 'react-router-dom';

import './style.scss';

const FooterV2 = () => {
    return <div className='loggedin-footer'>
        <div className='loggedin-footer__copy'>
            © {new Date().getFullYear()}
            {' '}
            Privaposts
        </div>
        <div className='loggedin-footer__links'>
            <ul>
                {/* <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/how-it-works">How It Works</Link>
                </li>
                <li>
                    <Link to="/referrals">Referrals</Link>
                </li> */}
                <li>
                    <Link to="/terms">Terms</Link>
                </li>
                <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                {/* <li>
                    <Link to="/logos">Logos</Link>
                </li>
                <li>
                    <Link to="https://priva.uvdesk.com/en/">Help & FAQs</Link>
                </li> */}
            </ul>
        </div>
    </div >;
};

export default FooterV2;